import { ComponentPropsWithoutRef } from 'react';

export default function BTCFilledSquare(
  props: ComponentPropsWithoutRef<'svg'>,
) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <path
        fill="#F7931A"
        d="M19.7,12.4c-1.3,5.4-6.8,8.6-12.1,7.3C2.2,18.4-1,12.9,0.3,7.6C1.6,2.2,7.1-1,12.4,0.3
	C17.8,1.6,21,7,19.7,12.4z"
      />
      <path
        fill="#FFFFFF"
        d="M14.4,8.6c0.2-1.3-0.8-2-2.2-2.5l0.4-1.8L11.6,4l-0.4,1.8c-0.3-0.1-0.6-0.1-0.9-0.2l0.4-1.8L9.6,3.5
	L9.1,5.3C8.9,5.2,8.7,5.2,8.4,5.1l0,0L6.9,4.7L6.6,5.9c0,0,0.8,0.2,0.8,0.2C7.9,6.2,8,6.5,7.9,6.7L7.4,8.8c0,0,0.1,0,0.1,0
	c0,0-0.1,0-0.1,0l-0.7,2.9c-0.1,0.1-0.2,0.3-0.5,0.3c0,0-0.8-0.2-0.8-0.2L4.9,13l1.4,0.4c0.3,0.1,0.5,0.1,0.8,0.2l-0.5,1.8l1.1,0.3
	l0.4-1.8C8.5,13.9,8.8,14,9,14.1l-0.4,1.8l1.1,0.3l0.5-1.8c1.9,0.4,3.3,0.2,3.9-1.5c0.5-1.4,0-2.1-1-2.7C13.7,10,14.3,9.5,14.4,8.6
	L14.4,8.6z M11.9,12.1c-0.3,1.4-2.6,0.6-3.4,0.4l0.6-2.4C9.9,10.3,12.3,10.7,11.9,12.1z M12.2,8.5C11.9,9.8,10,9.2,9.4,9l0.5-2.2
	C10.6,7,12.6,7.3,12.2,8.5L12.2,8.5z"
      />
    </svg>
  );
}
